import { useDispatch } from 'react-redux';
import { SubscriptionMaintenanceContabInputDto, SubscriptionMaintenanceContabOutputDto } from '@api/izibizi-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchSubscriptionMaintenance = (): UseFetchHookOutput<
	Omit<SubscriptionMaintenanceContabInputDto, 'metadata'>,
	SubscriptionMaintenanceContabOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<SubscriptionMaintenanceContabInputDto, SubscriptionMaintenanceContabOutputDto>({
		operationKey: 'subscriptionMaintenance',
		withLoading: false,
		onSuccess: (res) => {
			if (res) {
				dispatch(saveSuccessServiceResponse({ subscriptionMaintenance: res.data }));
			}
		},
	});
};
